export const documentCategories = {
    metric: 'Metric' as const,
    regression: 'Regression' as const,
    language: 'Language' as const,
    titleColors: 'TitleColors' as const,
    metricPool: 'MetricPool' as const,
    metricStandard: 'MetricStandard' as const,
    metricProcess: 'MetricProcess' as const,
    metricDerived: 'MetricDerived' as const,
    metricGroup: 'MetricGroup' as const,
    metricRegression: 'MetricRegression' as const,
    autoMetric: 'AutoMetric' as const,
    metricForecast: 'MetricForecast' as const,
    olapDocument: 'OlapMetricDocument' as const,
    olapMetric: 'MetricOlap' as const,
    record: 'Record' as const,
    tt: 'TranslationTable' as const,
    process: 'Process' as const,
    parameter: 'Parameter' as const,
    constant: 'Constant' as const,
    alert: 'Alert' as const,
    recordAlert: 'RecordAlert' as const,
    processAlert: 'ProcessAlert' as const,
    metricAlert: 'MetricAlert' as const,
    customFilterGroup: 'FilterPeerGroup' as const,

    dataSource: 'DataSource' as const,
    wsDataSource: 'WSDataSource' as const,
    dataSourceTable: 'DataSourceTable' as const,
    dataSourceWSMethod: 'DataSourceWSMethod' as const,

    folder: 'Folder' as const,
    report: 'Report' as const,

    view: 'View' as const,

    fileProviderTemplate: 'FileProviderTemplate' as const,
    fileProviderBatch: 'FileProviderBatch' as const,
    fileProviderDownloaderServer: 'FileProviderDownloaderServer' as const,
    fileProviderDownloaderTask: 'FileProviderDownloaderTask' as const,

    recordGraph: 'RecordsGraph' as const,

    filterGroup: 'GriverGroup' as const,
    titleColorList: 'TitleColors' as const,

    dimension: 'Dimension' as const,
    executionPlan: 'ExecutionPlan' as const,
    solutionConfigDocument: 'SolutionConfigDocument' as const,
    configurationSettings: 'Company.ConfigurationSettings' as const,
    constantDocument: 'ConstantDocument' as const,
    accelerator: 'DataCachingAccelerator' as const,
    dataCacheAccelerator: 'DataCacheAccelerator' as const,
    geoDatabase: 'GeoDatabase' as const,
    webService: 'WebService' as const,
    swimlaneGroup: 'SwimlaneGroup' as const,
    processFilterDefinition: 'ProcessFilterDefinition' as const,
    testCase: 'TestCase' as const,
    testGroup: 'TestGroup' as const,
    testSession: 'TestSession' as const,
    allTestCases: 'AllTestCases' as const
};
export type DocumentCategories = typeof documentCategories[keyof typeof documentCategories];
